























































































import Vue from 'vue';
import FirebaseWeb from '../firebase';
const firebase = new FirebaseWeb();
// @ts-ignore
import { navigateToPath } from '@/util';
export default Vue.extend({
    data() {
        return {
            langs: ['en', 'hi'],
        };
    },
    computed: {
        themeModel: {
            get() {
                return this.$vuetify.theme.dark;
            },
            set(val: boolean) {
                this.$vuetify.theme.dark = val;
                localStorage.setItem(
                    'dark',
                    JSON.stringify(this.$vuetify.theme.dark)
                );
            },
        },
        langModel: {
            get() {
                return this.$i18n.locale;
            },
            set(val: string) {
                this.$i18n.locale = val;
                localStorage.setItem('lang', this.$i18n.locale);
            },
        },
    },
    methods: {
        onSignoutClick() {
            this.logout();
        },
        routeToSpanion() {
            window.open('http://www.spanion.xyz', '_blank');
        },
        routeTo(path: any) {
            navigateToPath(path);
        },
        logout() {
            firebase
                .signOut()
                .then(() => {
                    this.$store.dispatch('RESET_STORE');
                    this.$store.dispatch(
                        'SHOW_SNACK',
                        this.$t('toast.success.sign-out')
                    );
                })
                .catch(() => {
                    this.$store.dispatch(
                        'SHOW_SNACK',
                        this.$t('toast.error.sign-out')
                    );
                });
        },
    },
    mounted() {
        this.langModel = localStorage.getItem('lang') == 'hi' ? 'hi' : 'en';
        this.themeModel =
            localStorage.getItem('dark') == 'false' ? false : true;
    },
});
